export default {
  default: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/layouts/default.vue").then(m => m.default || m),
  mobile: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/layouts/mobile.vue").then(m => m.default || m)
}